import VueRouter
from "vue-router";
import routes
from "./routes";

import { ref, set } from "firebase/database";

const router = new VueRouter({
    linkActiveClass: "active",
    mode: "history",
    routes,
    base: process.env.BASE_URL,
});

const originalPush = router.push;
router.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) {
        return originalPush.call(this, location, onResolve, onReject)
    }

    return originalPush.call(this, location).catch((err) => {
        if (VueRouter.isNavigationFailure(err)) {
            const e = {
                error: JSON.parse(JSON.stringify(err, Object.getOwnPropertyNames(err))),
            };

            const logInfo = { source: "Router", user: null, data: e };
            var userId = 0;
            if (this.$store != null && this.$store.state.signedIn == true) {
                userId = this.$store.state.user.UserId;
                logInfo.user = this.$store.state.user;
            }
            set(ref(this.$db, 'users/' + userId), logInfo)
                .then(() => {
                    console.log("Log...");
                })
                .catch((error) => {
                    console.error(error);
                });

            return err
        }
        return Promise.reject(err)
    })
}

export default router;